import React from 'react';
import { Button, Input } from 'antd';
import FileUpload from 'components/form/FileUploadPrivate';
import { fileNameFromKey } from 'utils/file';
import type { IrsLetterDto } from '../types';
import { irsLetterComplete } from '../validators';
import s from '../common.module.less';

interface Props {
    value: IrsLetterDto;
    onChange: (dto: IrsLetterDto) => void;
    onContinue: () => void;
    continueLabel?: string;
    // group 宿主（ProviderPayerModal）传 true：零侧边对齐标题、footer 分隔线通边
    flush?: boolean;
    // review 行内编辑：只渲染表单 body，动作按钮由宿主提供
    hideFooter?: boolean;
    onBack?: () => void;
    saving?: boolean;
}

// IRS Tax ID confirmation letter（原型 showIrsLetterModal，09/24 + 10/15）：CP 575 或 147C，W-9 不算。
// 文件 + 信上原样印刷的法定名称都要有才能 Continue
const IrsLetterStep = ({
    value,
    onChange,
    onContinue,
    onBack,
    saving,
    continueLabel = 'Continue',
    flush,
    hideFooter,
}: Props) => (
    <>
        <div className={`${s.modalBody} ${flush ? s.flushBody : ''}`}>
            <p className={s.irsIntro}>
                Upload the letter the IRS sent when your EIN was issued (CP 575). If you cannot find it, ask the IRS for
                a 147C replacement on the Business and Specialty Tax Line, usually the same day, and come back to this
                step. Payers match the legal name against the IRS record character for character, so copy it from the
                letter rather than from memory.
            </p>
            <div className={s.irsName}>
                <span className={s.subFieldLabel}>Legal name exactly as printed on the letter</span>
                <Input
                    size="large"
                    value={value.legalName || ''}
                    placeholder="e.g. SUNRISE BEHAVIORAL HEALTH PLLC"
                    maxLength={150}
                    onChange={(e) => onChange({ ...value, legalName: e.target.value })}
                />
            </div>
            <FileUpload
                uploadType="LICENSE"
                accept=".pdf,.jpg,.jpeg,.png"
                tips="PNG, JPG, PDF up to 10MB"
                value={value.fileUrl || ''}
                onChange={(fileUrl) => onChange({ ...value, fileUrl, fileName: fileNameFromKey(fileUrl) })}
            />
        </div>
        {!hideFooter && (
            <div className={`${s.modalFooter} ${flush ? s.flushFooter : ''}`}>
                <Button
                    type="primary"
                    block
                    size="large"
                    className={s.primaryBtn}
                    disabled={!irsLetterComplete(value)}
                    loading={saving}
                    onClick={onContinue}
                >
                    {continueLabel}
                </Button>
                {onBack && (
                    <Button block size="large" className={s.backBtn} onClick={onBack}>
                        Back
                    </Button>
                )}
            </div>
        )}
    </>
);

export default IrsLetterStep;
